module.exports = __webpack_public_path__ + "static/media/banner8.51a97e91.jpg";